import { useRef } from 'react';
import { uiFormat, uiText } from '../../i18n';
import { shake } from '../../ui/motion';
import { platform } from '../../platform';
import { StudioIcon } from './StudioIcon';
import { StudioSheet } from './StudioSheet';

/** Скидка «Сделать дешевле на 10%, с водяным знаком»: цену со скидкой присылает сервер (клиент цены не пересчитывает). */
export interface StudioCheapOffer {
  price: number;
  percent?: number;
}
/** Лист «Не хватает Circle» (APP-SPEC-5 §1.6, BotCore.poor): остаток, скидка с водяным знаком, «Пополнить» — «Баланс». */
export function StudioPoorSheet({
  price,
  balance,
  cheap,
  onClose,
  onCheap,
  onTopUp = () => {
    window.location.hash = '#balance';
  },
}: {
  price: number;
  balance: number;
  cheap: StudioCheapOffer | null;
  onClose(): void;
  onCheap(): void;
  onTopUp?(): void;
}) {
  const offer = useRef<HTMLButtonElement>(null);
  const need = Math.max(0, price - balance);
  const enough = !!cheap && cheap.price <= balance;
  const percent = cheap?.percent ?? 10;
  return (
    <StudioSheet title={uiFormat('Не хватает {0} C', need)} onClose={onClose}>
      <div className="bc-poor">
        <h2>{uiFormat('Не хватает {0} C', need)}</h2>
        <p>{uiFormat('На балансе {0} C, нужно {1} C', balance, price)}</p>
        <button
          ref={offer}
          type="button"
          className={`bc-po${enough ? '' : ' off'}`}
          aria-disabled={enough ? undefined : 'true'}
          onClick={() => {
            if (!enough) {
              shake(offer.current);
              platform.haptic('light');
              return;
            }
            onCheap();
          }}
        >
          <span className="ic">
            <b className="mono">%</b>
          </span>
          <span className="m">
            <b>{uiFormat('Сделать дешевле на {0}%, с водяным знаком', percent)}</b>
            <span>
              {!cheap
                ? uiText('Для этой работы скидки нет')
                : enough
                  ? uiFormat('Создать за {0} C вместо {1} C', cheap.price, price)
                  : uiFormat('Со скидкой всё равно не хватает {0} C', cheap.price - balance)}
            </span>
          </span>
          <span className="rt">
            <StudioIcon kind="chev" />
          </span>
        </button>
        <div className="cta">
          <button
            type="button"
            className="btn"
            onClick={() => {
              onClose();
              onTopUp();
            }}
          >
            {uiText('Пополнить')}
          </button>
        </div>
      </div>
    </StudioSheet>
  );
}
